<template>
  <!-- prepare report dialog -->
  <v-dialog v-model="dialog" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-center"> {{ feedbackText }}... </v-col>
        </v-row>

        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LoadingData",
  props: ["feedbackText"],
  data() {
    return {
      dialog: true,
    };
  },
};
</script>
